import { createApi } from '@reduxjs/toolkit/query/react'
import queryString from 'query-string';
import { ICars } from '../../types'
import axiosBaseQuery from './API'

// Define a service using a base URL and expected endpoints
interface IData {
  modelId:number,
  markId:number,
  options:string,
  carColor:string,
  mileage:number,
  engineVolume:number,
  hp:number,
  transmission:string,
  driveType:string,
  interier:string,
  interierColor:string,
  primaryDamage:string,
  year:number,
  price:number,
  phoneNumber:string
}
interface ICarData {
  delete: any,
  results:IData[]
}
interface IFilter {
  markId?:number,
  model?:number, 
  startYear?:number, 
  endYear?:number,
  priceFrom?:number,
  priceTo?:number,
  limit?:number,
  offset?:number
}
export const searchedCarsApi = createApi({
  reducerPath: 'searchedCars',
  tagTypes:['SearchedCars'],
  baseQuery: axiosBaseQuery({ baseUrl: process.env.REACT_APP_API_KEY }),
  endpoints: (builder) => ({
    getSearchedCars: builder.query<any, any>({
      query: (data) => {
        const stringified = queryString.stringify(data);
       return {url:`datas/all/?${stringified}`, method:'GET'}
      },
      providesTags: [{ type: 'SearchedCars' }],
    }),
    getSearchedCarsById: builder.query<any, {id?:string}>({
      query: ({id}) => {
       return {url:`datas/${id}`, method:'GET'}
      },
      providesTags: [{ type: 'SearchedCars' }],
    }),
   
    deleteSearchedCars: builder.mutation<ICars, {id:number | null}>({
      query({id}) {
        return {
          url: `datas/${id}`,
          method: 'DELETE',
        }
      },
      invalidatesTags: [{ type: 'SearchedCars'}],
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { 
  useGetSearchedCarsQuery, 
  useGetSearchedCarsByIdQuery,
  useDeleteSearchedCarsMutation 
 } = searchedCarsApi